export interface OutsideLink {
  label: string;
  href: string;
  title: string;
  aria: string;
}

/** "Website • Dealroom • Affinity" under a record's name; the caller passes only the links that exist. */
export function PaneLinks(props: { name: string; links: OutsideLink[] }): React.JSX.Element | null {
  if (props.links.length === 0) return null;
  return (
    <p className="pane-links">
      {props.links.map((link, index) => (
        <span key={link.label}>
          {index > 0 && (
            <span className="pane-links-sep" aria-hidden="true">
              {' • '}
            </span>
          )}
          <a
            href={link.href}
            target="_blank"
            rel="noreferrer"
            title={link.title}
            aria-label={`${props.name} ${link.aria}`}
          >
            {link.label}
          </a>
        </span>
      ))}
    </p>
  );
}
